import { styled } from "@mui/material/styles";
import { TableHead } from "@mui/material";

export const StyledTableHead = styled(TableHead)(({ theme }) => ({
  "& .MuiTableRow-root": {
    "& .MuiTableCell-root": {
      backgroundColor: theme.palette.background.paper,
      "&:first-of-type": {
        borderRadius: "5px 0px 0px 5px",
      },
      "&:last-of-type": {
        borderRadius: "0px 5px 5px 0px",
      },
    },
  },
}));
